const ModalMix={
    props:{
        showModal: {
            type: Boolean,
            default: false,
            note:'in true case show'
        }
    },
    methods: {
        emitirHide:function(){
           this.$emit('on-hide')
       },
   }
}
export {ModalMix}